import { useState, useCallback } from 'react';
import { COMPARISON_CATEGORIES } from '@/utils/constants';

export const useComparisonTabSelection = () => {
  const [tabSelections, setTabSelections] = useState<Record<string, number>>({
    [COMPARISON_CATEGORIES.TOP_HOLDINGS]: 10, // default value
  });

  const updateTabSelection = useCallback((categoryKey: string, value: number) => {
    setTabSelections(prev => ({
      ...prev,
      [categoryKey]: value,
    }));
  }, []);

  return { tabSelections, updateTabSelection };
};
